import { ButtonState, type PopupCallBackParam } from "commons/popup/store/absPopupVo";
import { rdxPopupOpen } from "commons/popup/store/popupR";
import { useDispatch } from "react-redux";
import { PopupType } from "../PopupType";
import { CustomButtonGroup } from "./CSVUploadPopup";
import { useApi } from "store/modules/common";
import { apiPuploadMSNFile } from "./CSVUploadR";
import { useClosePopup } from "commons/popup/store/absPopupHook";
import useLoading from "commons/loading/store/loadingHook";
import { useIConPopup } from "../popupHook";

/**
 * 팝업 open 및 리덕스 연결 이벤트 Hook
 */
export const useCSVUploadPopup = () => {
  const dispatch = useDispatch();
  return async (
    data?: {
      //
    },
    callBack?: (value: { state: ButtonState }) => void,
  ) => {
    const inCallBack = (result: PopupCallBackParam) => {
      if (callBack) {
        callBack(result as { state: ButtonState });
      }
    };
    dispatch(
      rdxPopupOpen({
        width: 500,
        type: PopupType.CSV_UPLOAD_POPUP,
        title: "MSN 데이터(CSV) 불러오기",
        data,
        buttonWrapper: CustomButtonGroup,
        callBack: inCallBack,
      }),
    );
  };
};

/**
 * 인사이트 MSN 업로드 API
 */
export const useInsightMSNUpload = () => {
  const { apiResult } = useApi();
  const { close } = useClosePopup(PopupType.CSV_UPLOAD_POPUP);
  const { on, off } = useLoading();
  const iconPopup = useIConPopup();

  const upload = async () => {
    on();
    const res = await apiResult(apiPuploadMSNFile);

    if (res) {
      // 현재 업로드 중인 상태라 작업불가인 경우
      if (res.code === 204) {
        close(ButtonState.OK);
        off();
        iconPopup("alert", {
          iconColor: "ff4949",
          iconType: "Closed",
          desc: res.message,
          title: "작업이 중지되었습니다.",
        });
      } else {
        // 현재 작업중인 상테가 아닌 경우
        // const result = await apiResult(apiPmsnDataRefresh);
        // if (result?.code === 200) {
        close(ButtonState.OK);
        off();
        iconPopup("alert", {
          iconColor: "ddff3d",
          iconType: "Check",
          desc: `새로 갱신된 레코드 수: ${res.data?.insert_record_count}`,
          title: "작업이 완료되었습니다.",
        });
        // }
      }
    }
  };

  return { upload };
};
